import React, { useLayoutEffect, useState } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import EbuCbuPieChart from "./eBuCbuPieChart";
import PlansTable from "pages/staffPerformance/plansTable";
import MnpPlansTable from "pages/staffPerformance/mnpPlansTable";

am4core.useTheme(am4themes_animated);

export default function PieChart({
  showEbuCbu,
  setShowEbuCbu,
  showColumnChart,
  setShowColumnChart,
  label,
  total,
  isHayyak,
  ebuLabel,
  cbuLabel,
  ebuPlans,
  cbuPlans,
  showMnpData
}) {
  const [type, setType] = useState("");

  useLayoutEffect(() => {
    const chart = am4core.create("chartdiv94", am4charts.PieChart);
    chart.hiddenState.properties.opacity = 0; // this makes initial fade in effect

    chart.data = label;

    // Add and configure Series
    var pieSeries = chart.series.push(new am4charts.PieSeries());
    pieSeries.dataFields.value = "litres";
    pieSeries.dataFields.category = "country";

    // Let's cut a hole in our Pie chart the size of 40% the radius
    chart.innerRadius = am4core.percent(40);

    // Set up fills
    pieSeries.slices.template.fillOpacity = 1;

    var hs = pieSeries.slices.template.states.getKey("hover");
    hs.properties.scale = 1;
    hs.properties.fillOpacity = 0.5;

    let totalLabel = chart.createChild(am4core.Label);
    totalLabel.text = `Total: ${total}`;
    totalLabel.fontSize = 20;
    totalLabel.align = "center";
    totalLabel.isMeasured = false;
    totalLabel.x = am4core.percent(50);
    totalLabel.horizontalCenter = "middle";
    totalLabel.y = am4core.percent(46);
    totalLabel.clickable = true;
    totalLabel.events.on("hit", () => (total > 0 ? setShowEbuCbu(true) : null));
    totalLabel.cursorOverStyle = am4core.MouseCursorStyle.pointer;

    // let revenueLabel = chart.createChild(am4core.Label);
    // revenueLabel.text = "Revenue: 10000";
    // revenueLabel.fontSize = 20;
    // revenueLabel.align = "center";
    // revenueLabel.isMeasured = false;
    // revenueLabel.x = am4core.percent(50);
    // revenueLabel.horizontalCenter = "middle";
    // revenueLabel.y = am4core.percent(52);
    // revenueLabel.clickable = true;
    // revenueLabel.events.on("hit", () => setShowEbuCbu(true));
    // revenueLabel.cursorOverStyle = am4core.MouseCursorStyle.pointer;

    // label.addEventListener("hit", function() {
    //   // Do something when the label is clicked
    //   alert("clicked")
    // });

    // const categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    // categoryAxis.renderer.grid.template.location = 0;
    // categoryAxis.dataFields.category = 'country';
    // categoryAxis.renderer.minGridDistance = 40;

    // const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

    // Modify chart's colors
    // chart.colors.list = CHART_COLORS;

    // const series = chart.series.push(new am4charts.CurvedColumnSeries());
    // series.dataFields.categoryX = 'country';
    // series.dataFields.valueY = 'value';
    // series.tooltipText = '{valueY.value}';
    // series.columns.template.strokeOpacity = 0;
    // series.columns.template.tension = 1;

    // series.columns.template.fillOpacity = 0.75;

    // const hoverState = series.columns.template.states.create('hover');
    // hoverState.properties.fillOpacity = 1;
    // hoverState.properties.tension = 0.8;

    // chart.cursor = new am4charts.XYCursor();

    // Add distinctive colors for each column using adapter
    // series.columns.template.adapter.add('fill', (fill, target) => chart.colors.getIndex(target.dataItem.index));

    // chart.scrollbarX = new am4core.Scrollbar();
    // chart.scrollbarY = new am4core.Scrollbar();

    // chart.current = chart;

    return () => {
      chart.dispose();
    };
  }, []);

  if (!showMnpData && showColumnChart) {
    return (
      <PlansTable data={type == "EBU" ? ebuPlans : cbuPlans} type={type} />
    ); // Change for show table
  }
  
  if (showMnpData && showColumnChart) {
    return <MnpPlansTable data={type == "Baqati" ? cbuPlans : ebuPlans } type={type} />
  }

  if (showEbuCbu) {
    return (
      <EbuCbuPieChart
        ebuLabel={ebuLabel}
        cbuLabel={cbuLabel}
        isHayyak={isHayyak}
        showMnpData={showMnpData}
        onClick={(type) => {
          setShowColumnChart(true);
          setType(type);
        }}
      />
    );
  }

  return (
    <div
      id="chartdiv94"
      style={{ width: "100%", height: "500px", direction: "ltr" }}
    />
  );
}
